import {
  createContext,
  ReactNode,
  useState,
  useCallback,
} from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import getTheme from '@/content/theme/themeModule';

const ThemeContext = createContext(
  (_themeName: string): void => {},
);

interface ThemeProviderProps {
  children?: ReactNode;
}

const ThemeProvider = ({ children = undefined }: ThemeProviderProps) => {
  const currentThemeName = localStorage.getItem('appTheme') || 'HolorayLightTheme';
  const [themeName, setThemeName] = useState(currentThemeName);
  const theme = getTheme(themeName);

  const setSelectedTheme = useCallback((selectedTheme: string): void => {
    localStorage.setItem('appTheme', selectedTheme);
    setThemeName(selectedTheme);
  }, []);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeContext.Provider value={setSelectedTheme}>
        <MuiThemeProvider theme={theme}>
          {children}
        </MuiThemeProvider>
      </ThemeContext.Provider>
    </StyledEngineProvider>
  );
};

export default ThemeProvider;
